import React from 'react'
import { inject, observer } from 'mobx-react'

import { CustomSelect } from '../../components/select'

export const CustomerSelector = inject('customerStore')(observer(({customerStore,...props}) =>
<CustomSelect {...props}
  options={customerStore.options}
/>))
